import { Add } from "@mui/icons-material";
import { Box, Button, Chip, Grid, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ERROR, MEDICINE_FREQUENCY_LIST, MEDICINE_ROUTE_OPTIONS, SOMETHING_WENT_WRONG } from "../../utils/constants";
import { SAVE_MEDICINE_INFO } from "../../utils/constants/redux";
import AHMIS, { API_URL } from "../../api/api";
import AddAlertMessage from "../alert/Alert";
import CustomReactSelect from "../custom-react-select/CustomReactSelect";
import { MEDICINE_TIMING } from "../../utils/constants/forms";
import { AppMisc } from "../../misc/appMisc";

export default function AddMedicineList(props) {
  const [medicineName, setMedicineName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [medicineDose, setMedicineDose] = useState("");
  const [medicineFrequency, setMedicineFrequency] = useState("");
  const [medicineRoute, setMedicineRoute] = useState("");
  const [medicineTiming, setMedicineTiming] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const dispatch = useDispatch();
  const medicineList = useSelector((state) => state.medicineInfo);
  const medicineOptions = medicineList?.map((item) => ({ value: item.medicineName, label: item.medicineName, phialCount: item.medicineUnit })) || [];

  useEffect(() => {
    if (!medicineList) {
      AHMIS.get(API_URL.medicineList)
        .then((response) => {
          const objectList = response.data?.data?.objectList;
          dispatch({ type: SAVE_MEDICINE_INFO, payload: objectList });
        })
        .catch(() => {
          AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
        });
    }
  }, []);

  const handleQuantityChange = event => {
    setQuantity(event.target.value);
  }

  const removeMedicineObject = item => {
    let medicineListAfterRemoval = props.medicineDetails.filter((medicineObject) => {
      return medicineObject.medicineName !== item.medicineName || medicineObject.quantity !== item.quantity;
    });
    props.onAddmedicineDetails(medicineListAfterRemoval);
  }

  function addAndClear(medicineObject) {
    props.onAddmedicineDetails(prev => [
      ...(Array.isArray(prev) ? prev : []),
      medicineObject,
    ]);

    setMedicineName("");
    setQuantity("");
    setMedicineDose("");
    setMedicineFrequency("");
    setMedicineRoute("");
    setMedicineTiming("");
    setShowErrorMessage(false);
  }

  const addToList = () => {
    let medicineObject = {
      medicineName: medicineName,
      medicineRoute: medicineRoute,
      dose: medicineDose,
      frequency: medicineFrequency,
      timing: medicineTiming,
      quantity: quantity
    }

    addAndClear(medicineObject)
  }

  const handleMedicineNameChange = (name, value, options) => {
    setMedicineName(value)
    setQuantity(options?.phialCount || "")
  }

  const handleMedicineTimingChange = (value) => {
    setMedicineTiming(value)
  }

  const handleMedicineDoseChange = event => {
    setMedicineDose(event.target.value);
  }

  const handleMedicineFrequencyChange = value => {
    setMedicineFrequency(value);
  };

  const handleMedicineRouteChange = (name, value) => {
    setMedicineRoute(value);
  }

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <CustomReactSelect
            name="medicineName"
            label="Medicine Name"
            options={medicineOptions}
            defaultValue={medicineName}
            onChange={handleMedicineNameChange}
            creatable
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            size="small"
            type="number"
            onWheel={(e) => e.target.blur()}
            value={quantity}
            label="फायल (संख्या)"
            placeholder="Eg: 10"
            name="quantity"
            variant="outlined"
            onChange={handleQuantityChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            size="small"
            value={medicineDose}
            label="Dose"
            placeholder="eg: 7.5 ml"
            name="dose"
            variant="outlined"
            onChange={handleMedicineDoseChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomReactSelect
            label="Route"
            name="medicineRoute"
            options={MEDICINE_ROUTE_OPTIONS}
            defaultValue={medicineRoute}
            onChange={handleMedicineRouteChange}
            creatable
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomReactSelect
            name="frequency"
            label="Frequency"
            options={MEDICINE_FREQUENCY_LIST}
            onChange={(...params) => handleMedicineFrequencyChange(params[1])}
            defaultValue={medicineFrequency}
            creatable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CustomReactSelect
            name="medicineTiming"
            label="Timing"
            options={MEDICINE_TIMING}
            onChange={(...params) => handleMedicineTimingChange(params[1])}
            defaultValue={medicineTiming}
            creatable
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Button size="small" type="button" variant="contained" color="primary" startIcon={<Add />} onClick={addToList}>{props.addToListButtonText}</Button>
        </Grid>
      </Grid>
      {
        showErrorMessage &&
        <span className="error-message">{props.requiredErrorMessage}</span>
      }
      <Box mt={2}>
        {
          props?.medicineDetails?.map((item, index) => (
            <Chip
              key={index}
              label={AppMisc.getReadableFormatFromMedicineObject(item, medicineOptions)}
              onDelete={() => removeMedicineObject(item)}
            />
          ))
        }
      </Box>
    </Box>
  );
}

AddMedicineList.propTypes = {
  addToListButtonText: PropTypes.string,
  requiredErrorMessage: PropTypes.string,
};

AddMedicineList.defaultProps = {
  addToListButtonText: "Add To List",
  requiredErrorMessage: "कृपया औषधीको नाम र संख्या चयन गर्नुहोस्।"
};